import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
  },
];

export const HealthCenterHealthCheckupAnalysisSex = {
  label: "衛生所健檢分析(性別)",
  key: "HealthCenterHealthCheckupAnalysisSex",
  path: "HealthCenterHealthCheckup/HealthCenterHealthCheckupAnalysisSex",
  api: "TCS_V_HCCS01",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.HealthCenterHealthCheckupAnalysisSex
      {...options}
    />
  ),
  isGroup: true,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  groupColumns: [
    {
      key: "性別",
      field: "性別",
      header: "",
    },
  ],
  filterColumns: [
    { key: "填表次序", type: "string" },
    { key: "年齡層", type: "string" },
    { key: "縣市", type: "string" },
    { key: "鄉鎮", type: "string" },
    { key: "衛生所", type: "string" },
  ],
  levelColumns,
  columns: [],
};
